import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=400b8163&scoped=true"
import script from "./DetailPage.vue?vue&type=script&lang=js"
export * from "./DetailPage.vue?vue&type=script&lang=js"
import style0 from "./DetailPage.vue?vue&type=style&index=0&id=400b8163&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400b8163",
  null
  
)

export default component.exports